import Header from "./Header";
import Footer from "./Footer";
import AIAssistantWidget from "./AIAssistantWidget";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <AIAssistantWidget />
    </div>
  );
}
